/**
 * Pure display helpers for the add-on catalog (ADR-0263 §2.5).
 */

import type { AdminPlanAddonKind, AdminPlanScope } from '@sill/types/api';

/** Human label for each add-on kind. */
export function addonKindLabel(kind: AdminPlanAddonKind): string {
  switch (kind) {
    case 'extra_free_site':
      return 'Extra Free site';
    case 'page_loads_pack':
      return 'Page-load pack';
    case 'orders_pack':
      return 'Order pack';
  }
}

/** Short unit hint (plural) that follows the `unit_value` number in
 *  the catalog table. "1 extra Free site" / "10,000 page loads" / etc. */
export function addonUnitHint(kind: AdminPlanAddonKind): string {
  switch (kind) {
    case 'extra_free_site':
      return 'Free site';
    case 'page_loads_pack':
      return 'page loads';
    case 'orders_pack':
      return 'orders';
  }
}

/** DB CHECK pairs each kind with a mandatory scope. */
export const KIND_SCOPE: Readonly<Record<AdminPlanAddonKind, AdminPlanScope>> = {
  extra_free_site: 'account',
  page_loads_pack: 'site',
  orders_pack: 'site',
};

export const ALL_ADDON_KINDS: readonly AdminPlanAddonKind[] = [
  'extra_free_site',
  'page_loads_pack',
  'orders_pack',
];
